export const STEPS = {
  main: 'main',
  otp_email: 'otp_email',
  referral: 'referral',
  phone: 'phone',
  veriff: 'veriff',
};
